import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const ManagerProfile = ({ userData }) => {
  return (
    <div>
      {/* Profile Section */}
      <Container className="py-5">
        <Row>
          <Col lg={4}>
            <Card className="mb-4">
              <Card.Body className="text-center">
               <img
                  src={userData.pic ? userData.pic : 'https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-chat/ava3.webp'}
                  alt="avatar"
                  className="rounded-circle img-fluid"
                  style={{ width: '150px' }}
                />
                <h5 className="my-2">{userData.name}</h5>
                <p className="text-muted mb-1">{userData.role}</p>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={8}>
            <Card className="mb-4">
              <Card.Body>
                {/* Profile Information */}
                <Row>
                  <Col sm={3}><p className="mb-0">Name</p></Col>
                  <Col sm={9}><p className="text-muted mb-0">{userData.name}</p></Col>
                </Row>
                <hr />
                <Row>
                  <Col sm={3}><p className="mb-0">Email</p></Col>
                  <Col sm={9}><p className="text-muted mb-0">{userData.email}</p></Col>
                </Row>
                <hr />
                <Row>
                  <Col sm={3}><p className="mb-0">Phone</p></Col>
                  <Col sm={9}><p className="text-muted mb-0">{userData.phone}</p></Col>
                </Row>

                {/* Additional Info for Manager */}
                <Row>
                  <Col sm={3}><p className="mb-0">Company</p></Col>
                  <Col sm={9}><p className="text-muted mb-0">{userData.company}</p></Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ManagerProfile;
